document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.om-text-title').forEach((el) => {
    el.textContent = el.textContent.normalize('NFC');
  });
});
